import { render, staticRenderFns } from "./AddValue.vue?vue&type=template&id=784bd821&"
import script from "./AddValue.vue?vue&type=script&lang=js&"
export * from "./AddValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports